import { gql } from '@apollo/client';

export const RESULT_FIELDS = gql`
  fragment ResultFields on Result {
    runner_id
    race_id
    horse_id
    horse_name
    position
    margin
    price_sp
    prizemoney_won
    jockey
    trainer
    barrier
    weight
    position_finish
    position_settling
    position_800m
    position_400m
  }
`;
